module.exports = __webpack_public_path__ + "static/media/guest-default.d138163a.gif";